import { KeyboardEvent } from 'react';

// Таблица соответствий клавиш (русская раскладка -> английская раскладка)
const russianToEnglishMap: { [key: string]: string } = {
  'а': 'f', 'б': ',', 'в': 'd', 'г': 'u', 'д': 'l', 'е': 't', 'ё': '`', 'ж': ';', 'з': 'p',
  'и': 'b', 'й': 'q', 'к': 'r', 'л': 'k', 'м': 'v', 'н': 'y', 'о': 'j', 'п': 'g', 'р': 'h',
  'с': 'c', 'т': 'n', 'у': 'e', 'ф': 'a', 'х': '[', 'ц': 'w', 'ч': 'x', 'ш': 'i', 'щ': 'o',
  'ъ': ']', 'ы': 's', 'ь': 'm', 'э': '\'', 'ю': '.', 'я': 'z', 'А': 'F', 'Б': '<', 'В': 'D',
  'Г': 'U', 'Д': 'L', 'Е': 'T', 'Ё': '~', 'Ж': ':', 'З': 'P', 'И': 'B', 'Й': 'Q', 'К': 'R',
  'Л': 'K', 'М': 'V', 'Н': 'Y', 'О': 'J', 'П': 'G', 'Р': 'H', 'С': 'C', 'Т': 'N', 'У': 'E',
  'Ф': 'A', 'Х': '{', 'Ц': 'W', 'Ч': 'X', 'Ш': 'I', 'Щ': 'O', 'Ъ': '}', 'Ы': 'S', 'Ь': 'M',
  'Э': '"', 'Ю': '>', 'Я': 'Z', '"': '@'
};

/**
 * Преобразует русский символ в английский эквивалент на основе раскладки клавиатуры
 */
export const convertToEnglish = (char: string): string => {
  return russianToEnglishMap[char] || char;
};

/**
 * Обрабатывает ввод с клавиатуры, автоматически преобразуя русские символы в английские
 */
export const handlePositionBasedInput = (
  event: KeyboardEvent<HTMLDivElement>,
  onValueChange: (fieldName: string, value: string) => void
) => {
  const char = event.key;
  const englishChar = convertToEnglish(char);
  
  if (englishChar !== char) {
    event.preventDefault();
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;

    const newValue = value.slice(0, start) + englishChar + value.slice(end);
    target.value = newValue;
    target.setSelectionRange(start + 1, start + 1);

    // Вызываем callback для обновления состояния
    if (target.name) {
      onValueChange(target.name, newValue);
    }
  }
};

/**
 * Хук для обработки конвертации раскладки клавиатуры
 */
export const useKeyboardLayoutConverter = (
  setLogin: (value: string) => void,
  setPassword: (value: string) => void
) => {
  const handleValueChange = (fieldName: string, value: string) => {
    if (fieldName === 'login') {
      setLogin(value);
    } else if (fieldName === 'password') {
      setPassword(value);
    }
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => {
    handlePositionBasedInput(event, handleValueChange);
  };

  return { handleKeyPress };
};
